// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowUpSmall = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowUpSmall = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowUpSmall = _exports.ArrowUpSmall = function ArrowUpSmall(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.775 7.11004C13.6533 7.23171 13.4933 7.29335 13.3333 7.29335C13.1733 7.29335 13.0133 7.23254 12.8916 7.11004L10.625 4.8434V16.6683C10.625 17.0133 10.345 17.2933 9.99998 17.2933C9.65498 17.2933 9.37498 17.0133 9.37498 16.6683V4.84421L7.10834 7.11085C6.86417 7.35502 6.46831 7.35502 6.22414 7.11085C5.97997 6.86669 5.97997 6.47082 6.22414 6.22666L9.55747 2.89333C9.61497 2.83583 9.68405 2.7901 9.76072 2.75844C9.91322 2.6951 10.0857 2.6951 10.2382 2.75844C10.3149 2.7901 10.3842 2.83583 10.4417 2.89333L13.775 6.22666C14.0192 6.47082 14.0192 6.86587 13.775 7.11004Z",
      fill: "currentColor"
    }));
  };
});
